import { render, staticRenderFns } from "./MunicipalitiesBar.vue?vue&type=template&id=ef237a12&scoped=true&"
import script from "./MunicipalitiesBar.vue?vue&type=script&lang=js&"
export * from "./MunicipalitiesBar.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalitiesBar.vue?vue&type=style&index=0&id=ef237a12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef237a12",
  null
  
)

export default component.exports